import {useMemo} from "react";

import {USER_ROLES} from "@constants";
import {usePricingDiscountRoleConfig} from "../../../@hooks";


export default function usePriceDiscountCountryWiseText() {
	const { userRole } = usePricingDiscountRoleConfig()

	const {title, averageLabel, skuLabel, titleX, titleY} = useMemo(() => ({
		[USER_ROLES.STANDARD]: {
			title: 'Products & Average Discount Map',
			averageLabel: 'Average Discount',
			skuLabel: "Offers with discount",
			titleX: "Discount percentage",
			titleY: "Products with discount"
		},
		[USER_ROLES.MARKETPLACES]: {
			title: 'Products & Average Discount Map',
			averageLabel: 'Average Discount',
			skuLabel: "Offers with discount",
			titleX: "Discount percentage",
			titleY: "Products with discount"
		},
		[USER_ROLES.RETAILER]: {
			title: 'Products & Average Price Dispersion Map',
			averageLabel: 'Average Price Dispersion',
			skuLabel: "Offers with dispersion",
			titleX: "Dispersion percentage",
			titleY: "Products with dispersion"
		},
	})[userRole], [userRole])

	return {
		title,
		averageLabel,
		skuLabel,
		titleX,
		titleY
	}
}